import { useState } from 'react';
import { PRIORITIES, STATUSES, NOTE_TYPES, MATTER_TYPES, today } from '../lib/ui';
import { Btn, Input, Select, Textarea, Field, Avatar } from '../lib/ui';
import Modal from './Modal';

export function AddMatterModal({ team, onClose, onSave }) {
  const [f, setF] = useState({
    name:'', client:'', type:'', owner_id: team[0]?.id||'',
    status:'Not Started', priority:'Medium',
    start_date: today(), deadline:'', description:''
  });
  const valid = f.name.trim() && f.client.trim();
  return (
    <Modal title="New Matter" onClose={onClose} wide>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
        <Field label="Matter Name" col="1 / -1"><Input value={f.name} onChange={e=>setF({...f,name:e.target.value})} placeholder="e.g. AgaOne bank account opening" /></Field>
        <Field label="Client"><Input value={f.client} onChange={e=>setF({...f,client:e.target.value})} /></Field>
        <Field label="Matter Type"><Select value={f.type} onChange={e=>setF({...f,type:e.target.value})}><option value="">—</option>{MATTER_TYPES.map(t=><option key={t}>{t}</option>)}</Select></Field>
        <Field label="Priority"><Select value={f.priority} onChange={e=>setF({...f,priority:e.target.value})}>{PRIORITIES.map(p=><option key={p}>{p}</option>)}</Select></Field>
        <Field label="Status"><Select value={f.status} onChange={e=>setF({...f,status:e.target.value})}>{STATUSES.map(s=><option key={s}>{s}</option>)}</Select></Field>
        <Field label="Owner"><Select value={f.owner_id} onChange={e=>setF({...f,owner_id:e.target.value})}>{team.map(t=><option key={t.id} value={t.id}>{t.name}</option>)}</Select></Field>
        <Field label="Deadline"><Input type="date" value={f.deadline} onChange={e=>setF({...f,deadline:e.target.value})} /></Field>
        <Field label="Start Date"><Input type="date" value={f.start_date} onChange={e=>setF({...f,start_date:e.target.value})} /></Field>
        <Field label="Description / Summary" col="1 / -1"><Textarea rows={4} value={f.description} onChange={e=>setF({...f,description:e.target.value})} placeholder="Brief summary of this matter…" /></Field>
      </div>
      <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:20 }}>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
        <Btn onClick={()=>valid&&onSave(f)} style={{ opacity:valid?1:0.5 }}>Create Matter</Btn>
      </div>
    </Modal>
  );
}

export function AddTaskModal({ team, onClose, onSave }) {
  const [f, setF] = useState({ title:'', description:'', assignees:[], priority:'Medium', status:'Not Started', deadline:'', estimated:'' });
  const valid = f.title.trim();
  const toggle = id => setF(p => ({ ...p, assignees: p.assignees.includes(id) ? p.assignees.filter(x=>x!==id) : [...p.assignees, id] }));
  return (
    <Modal title="Add Task" onClose={onClose}>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }}>
        <Field label="Task Title" col="1 / -1"><Input value={f.title} onChange={e=>setF({...f,title:e.target.value})} placeholder="e.g. Review client documents" /></Field>
        <Field label="Priority"><Select value={f.priority} onChange={e=>setF({...f,priority:e.target.value})}>{PRIORITIES.map(p=><option key={p}>{p}</option>)}</Select></Field>
        <Field label="Status"><Select value={f.status} onChange={e=>setF({...f,status:e.target.value})}>{STATUSES.map(s=><option key={s}>{s}</option>)}</Select></Field>
        <Field label="Deadline"><Input type="date" value={f.deadline} onChange={e=>setF({...f,deadline:e.target.value})} /></Field>
        <Field label="Estimated Hours"><Input type="number" value={f.estimated} onChange={e=>setF({...f,estimated:e.target.value})} placeholder="e.g. 4" /></Field>
        <Field label="Assign To" col="1 / -1">
          <div style={{ display:'flex', gap:8, flexWrap:'wrap', paddingTop:4 }}>
            {team.map(m => {
              const on = f.assignees.includes(m.id);
              return (
                <label key={m.id} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13, cursor:'pointer',
                  background:on?'#1B2A4A11':'transparent', borderRadius:20, padding:'5px 12px',
                  border:on?'1px solid #1B2A4A33':'1px solid #E0DADA' }}>
                  <input type="checkbox" style={{ display:'none' }} checked={on} onChange={()=>toggle(m.id)} />
                  <Avatar name={m.name} size={22} />
                  <span style={{ fontWeight:on?700:400 }}>{m.name}</span>
                </label>
              );
            })}
          </div>
        </Field>
        <Field label="Description" col="1 / -1"><Textarea value={f.description} onChange={e=>setF({...f,description:e.target.value})} placeholder="Details about this task…" /></Field>
      </div>
      <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:20 }}>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
        <Btn onClick={()=>valid&&onSave(f)} style={{ opacity:valid?1:0.5 }}>Add Task</Btn>
      </div>
    </Modal>
  );
}

export function AddNoteModal({ team, onClose, onSave }) {
  const [f, setF] = useState({ type:'General', text:'', author: team[0]?.name||'' });
  const valid = f.text.trim();
  return (
    <Modal title="Add Note" onClose={onClose}>
      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        <Field label="Note Type"><Select value={f.type} onChange={e=>setF({...f,type:e.target.value})}>{NOTE_TYPES.map(t=><option key={t}>{t}</option>)}</Select></Field>
        <Field label="Author"><Select value={f.author} onChange={e=>setF({...f,author:e.target.value})}>{team.map(t=><option key={t.id} value={t.name}>{t.name}</option>)}</Select></Field>
        <Field label="Note"><Textarea rows={6} value={f.text} onChange={e=>setF({...f,text:e.target.value})} placeholder="Write your note here…" /></Field>
      </div>
      <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:20 }}>
        <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
        <Btn variant="gold" onClick={()=>valid&&onSave(f)} style={{ opacity:valid?1:0.5 }}>Save Note</Btn>
      </div>
    </Modal>
  );
}
